export const TAB_ITEMS = {
    IMAGES: "images",
    FLOORPLANS: "floorplans",
};
